import * as H from "@radix-ui/react-hover-card"
import { cn, tv } from "@utils/tw"
import { ReactNode } from "react"

type Props = {
  /**
   * The trigger element that will be used to open the card.
   */
  children: ReactNode
  /**
   * The contents to display in the card
   */
  content: ReactNode
  /**
   * A class name to apply to the hover card container
   */
  className?: string
  /**
   * @default 700
   */
  openDelay?: number
  /**
   * @default 300
   */
  closeDelay?: number
  /** @default "bottom" */
  side?: "top" | "right" | "bottom" | "left"
  /** @default "center" */
  align?: "start" | "center" | "end"
  /**
   * Whether to show an arrow or not
   * @default true
   **/
  arrow?: boolean
}

export function HoverCard(props: Props) {
  const styles = cardStyles()
  return (
    <H.Root openDelay={props.openDelay} closeDelay={props.closeDelay}>
      <H.Trigger asChild>{props.children}</H.Trigger>
      <H.Portal>
        <H.Content
          className={cn(styles.content(), props.className)}
          side={props.side}
          align={props.align}
          collisionPadding={20}
        >
          <div className={styles.inner()}>
            {props.arrow !== false && <H.Arrow className={styles.arrow()} />}
            {props.content}
          </div>
        </H.Content>
      </H.Portal>
    </H.Root>
  )
}

const cardStyles = tv({
  slots: {
    content: ["z-50 will-change-transform"],
    inner: ["bg-white shadow-popover rounded-sm overflow-hidden outline-none radix-hovercard-animation"],
    arrow: "fill-white stroke-2 stroke-primary/10 drop-shadow-sm transform -translate-y-[1px]",
    close: "absolute top-2 right-2",
  },
})
